<app-floating-configurator />
<div class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
  <div class="flex flex-col items-center justify-center">
    <div style="border-radius: 43px; padding: 0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)">
      <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20" style="border-radius: 43px">
        <div class="text-center flex flex-col items-center mb-8">
          <img src="/logo.png" alt="REI Logo" width="250" class="mb-4" />
          <div class="text-surface-900 dark:text-surface-0 text-3xl font-medium mb-4">REI Item</div>
          <span class="text-muted-color font-medium">Connectez-vous pour continuer</span>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
          <p-floatlabel variant="in" class="mb-6">
            <p-iconfield>
              <p-inputicon class="pi pi-user" />
              <input pInputText type="email" id="email" formControlName="email" pSize="large" class="w-full md:w-[30rem]" />
            </p-iconfield>
            <label for="email">Identifiant</label>
          </p-floatlabel>
          
          <p-floatlabel variant="in" class="mb-6">
            <p-iconfield>
              <p-inputicon class="pi pi-lock" />
              <input pInputText type="password" id="password" formControlName="password" pSize="large" class="w-full md:w-[30rem]" />
              <!-- <p-password id="password" formControlName="password" size="large" [toggleMask]="true" styleClass="mb-4" [fluid]="true" [feedback]="false"></p-password> -->
            </p-iconfield>
            <label for="password">Mot de passe</label>
          </p-floatlabel>

          <div class="flex items-center justify-between mt-2 mb-8 gap-8">
            <span class="font-medium no-underline ml-2 text-right cursor-pointer text-primary">Mot de passe oublié?</span>
          </div>
          <!-- <p-button type="submit" [disabled]="!loginForm.valid" label="Se connecter" [icon]="isLoggingIn ? '' : 'pi pi-sign-in'" [loadingIcon]="isLoggingIn ? 'pi pi-spin pi-spinner' : ''" [loading]="isLoggingIn" styleClass="w-full"></p-button> -->
          <p-button type="submit" label="Se connecter" [icon]="isLoggingIn ? '' : 'pi pi-sign-in'" [loadingIcon]="isLoggingIn ? 'pi pi-spin pi-spinner' : ''" [loading]="isLoggingIn" styleClass="w-full"></p-button>
        </form>
      </div>
    </div>
  </div>
</div>